import { MotionConfig } from "framer-motion";

export const MotionProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <MotionConfig
      transition={{
        type: "spring",
        duration: 1.5,
        bounce: 0,
      }}
    >
      {children}
    </MotionConfig>
  );
};
